import Link from "next/link";
import React from "react";
import { RiNotification3Fill } from "react-icons/ri";
const NotificationsCard = ({ notifications }) => (
  <div className="eelative">
    {/* <div className="flex items-center justify-between mb-4">
      <RiNotification3Fill className="text-accent text-2xl" />
      <Link
        href="/dashboard/notifications"
        className="text-jacarta-800 dark:text-accent"
      >
        View All →
      </Link>
    </div>
    <h3 className="text-lg font-display mb-4">Recent Notifications</h3> */}
    <div className="space-y-4">
      {notifications.map((notif, index) => (
        <div
          key={index}
          className="p-3 rounded-xl bg-jacarta-50 dark:bg-jacarta-700 hover:bg-accent/5 
                       dark:hover:bg-accent/10 transition-colors cursor-pointer"
        >
          <div className="flex items-start gap-3">
            <span
              className={`p-2 rounded-lg ${
                notif.type === "alert"
                  ? "bg-red-500/10 text-red-500"
                  : notif.type === "success"
                  ? "bg-green-500/10 text-green-500"
                  : "bg-accent/10 text-accent"
              }`}
            >
              {notif.icon}
            </span>
            <div>
              <p className="text-sm font-medium text-jacarta-700 dark:text-white">
                {notif.title}
              </p>
              <p className="text-xs text-jacarta-700 dark:text-jacarta-300 mt-1">
                {notif.message}
              </p>
              <p className="text-xs text-jacarta-600 dark:text-jacarta-400 mt-1">
                {notif.time}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default NotificationsCard;
